import { BaseModel, Resource, Form, Entry, EntryTypes } from '@ngx-resource-toolkit/core';
// import { FamilleModel } from '../../../famille/models/famille.model';
import { environment } from '../../../../environments/environment';
import { DateHelper } from '../../helpers/date.helper';
import { LeaResource } from '../../resource/lea.resource';
import { Validators, ValidatorFn } from '@angular/forms';
import { modePaimentFetchOptions } from '../../resource/select-options';
import { TABLE } from '../../../app.constantes';
import { FormatHelper } from '../../helpers/format.helper';
import { FormControl } from '@angular/forms/src/model';
import * as moment from 'moment';

/*const validModePaiementFn: ValidatorFn = (control) => {
	console.log(control);
	return null;
}*/
export class PaiementValidator {
	static validModePaiementFn(fc: FormControl) {
		// console.log('validModePaiementFn', fc);
	  if (fc.value === null || fc.value === 1) {
		return ({validModePaiementFn: true});
	  } else {
		return (null);
	  }
	}
  }

@Form({
    'create': {
		onChanges: (value: FamilleIdModel, form: any) => {
			// console.log('onChanges create ', value, form);
		}
	}
})
export class FamilleIdModel extends BaseModel {

	@Entry({
		'create': {
			hidden: true
		}
	})
	id: string;

	nom: string;

	constructor(id, data) {
		super();
		this.id = id;
		this.nom = data ? (data.nom ? data.nom : '') : '';
	}
}

@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/paiement',
            methods: LeaResource.methods,
        }
    },
})
@Form({
    'create': {
		// onChanges: (value: PaiementModel, form: any) => {
		// 	const montantPaiement: string = form.value['montantPaiement'];
		// 	if (montantPaiement) {
		// 		console.log("???????????????????????????????????????", montantPaiement);
		// 		form.patchValue({ montantPaiement: montantPaiement.replace(',', '.') }, { emitEvent: false });
		// 	}
		// 	const tireur: string = form.value['tireur'];
		// 	if (tireur) {
		// 		form.patchValue({ tireur: tireur.toUpperCase() }, { emitEvent: false });
		// 	}
		// 	const etabPayeur: string = form.value['etabPayeur'];
		// 	if (etabPayeur) {
		// 		console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!" , etabPayeur['libelle']);
		// 		form.patchValue({ etabPayeur: etabPayeur['libelle'].charAt(0).toUpperCase() + etabPayeur['libelle'].substring(1) }, { emitEvent: false });
		// 	}
		// }
	},
    'show': {},
})
export class PaiementModel extends BaseModel {
	@Entry({
		'create': {
			hidden: true,
		}
	})
	_explicitType: string = 'Paiement';

	@Entry({
		'create': {
			hidden: true,
		}
	})
	anneeScolaire: string;

	@Entry({
		base: {
			hidden: true,
		},
		'create': {
		},
		'table': {
			label: 'N°',
			minWidth: TABLE.MIN_WIDTH.ID,
			colOrder: 1,
        },
        'show': {
            type: EntryTypes.STATIC,
            label: 'N°',
            css: {
				group: 'col-xs-12',
				label: 'col-xs-4',
				input: 'col-xs-8'
			},
        }
	})
	id: number;

	@Entry({
        base: {
			label: 'N° Bordereau',
			colOrder: 2,
        },
		'table': {
        	minWidth: TABLE.MIN_WIDTH.BORDEREAU,
        },
        'show': {
            type: EntryTypes.STATIC,
            css: {
				group: 'col-xs-12',
				label: 'col-xs-4',
				input: 'col-xs-8'
			},
        }
	})
	bordereauNumero: string;

	@Entry({
		'table': {
			type: EntryTypes.DATE,
			format: 'YYYY-MM-DD',
			label: 'Date Bordereau',
			colOrder: 3,
			minWidth: TABLE.MIN_WIDTH.DATE,
		}
	})
	bordereauDate: string;

	@Entry({
        base: {
            label: 'Type de paiement',
            css: {
                group: 'col-xs-12',
                label: 'col-xs-4',
                input: 'col-xs-8'
            },
        },
		'create': {
			type: EntryTypes.SELECT,
            default: true,
			options: [{
				value: false,
				label: 'Paiement'
			}, {
				value: true,
				label: 'Remboursement'
			}]
        },
        'show': {
            type: EntryTypes.STATIC,
            transform: (value, row) => value ? 'Remboursement' : 'Paiement',
        },
	})
	isRemboursement: boolean; // Remboursement d'une famille

	@Entry({
		'create': {
			nested: true,
			hidden: true
		},
		'table': {
			hidden: true, // déplacé dans familleNom
			label: 'Famille',
			transform: (value, row) =>
				// value ? (value.nom + ' (' + value.id + ')') : ''
				value ? value.nom : ''
			,
			minWidth: TABLE.MIN_WIDTH.NOM_PRENOM,
		}
	})
	famille: FamilleIdModel;

	@Entry({
		'create': {
			hidden: true
		},
		'table': {
			hidden: false,
			label: 'Famille',
			colOrder: 4,
			minWidth: TABLE.MIN_WIDTH.NOM_PRENOM,
		}
	})
	familleNom: string;
	@Entry({
		'table': {
			hidden: false,
			label: 'N° f',
			colOrder: 5,
			minWidth: TABLE.MIN_WIDTH.ID,
		}
	})
	familleId: number;

	@Entry({
        base: {
            label: 'Mode de paiement',
			css: {
				group: 'col-xs-12',
				label: 'col-xs-4',
				input: 'col-xs-8'
            },
            /*transform: (value) => {
				switch (parseInt(value)) {
					case 1: return 'Chèque';
					case 2: return 'Espèces';
					case 3: return 'Chèque dépot';
					case 4: return 'Avoir';
					case 5: return 'Autre';
					default: return '';
				}
			}*/
			transform: (value, row) => {
				// console.log('transform', value, row);
				return row.libelleTypePaiement;
			},
			compareFn: (one, two) => {
				const un = (one && one.id) ? one.id : one;
				const deux = (two && two.id) ? two.id : two;
				// console.log('compareFn', { one, un, two, deux, equal: un==deux});
				return un == deux;
			},
        },
		'create': {
			type: EntryTypes.SELECT,
			// fetchOptions: modePaimentFetchOptions,
			validators: [Validators.required, PaiementValidator.validModePaiementFn],
			validatorsMsgs: {
				'required': 'Le mode de paiement est obligatoire',
				'validModePaiementFn': 'Le mode de paiement est obligatoire',
			},
        },
        'show': {
            type: EntryTypes.STATIC,
        },
		'table': {
			type: EntryTypes.TEXT,
			minWidth: TABLE.MIN_WIDTH.PAIEMENT_MODE,
            colOrder: 7,
            default: 1,
		}
	})
	type: number;

	@Entry({
        base: {
			label: 'libelleTypePaiement',
			type: EntryTypes.TEXT,
			hidden: true,
        },
		'create': {},
        'show': {},
		'table': {
            minWidth: TABLE.MIN_WIDTH.PAIEMENT_TYPE,
        }
	})
	libelleTypePaiement: string;

	@Entry({
		base: {
			type: EntryTypes.TEXT,
			label: 'Numéro',
			css: {
				group: 'col-xs-12',
				label: 'col-xs-4',
				input: 'col-xs-8'
			},
        },
        'create': {},
        'show': {
            type: EntryTypes.STATIC,
        },
		'table': {
			minWidth: TABLE.MIN_WIDTH.PAIEMENT_NUMERO,
			colOrder: 9,
		}
	})
	numero: string;

	@Entry({
        base: {
            label: 'Date prévisionnelle d\'encaissement',
			css: {
				group: 'col-xs-12',
				label: 'col-xs-4',
				input: 'col-xs-8'
			},
        },
		'create': {
			type: EntryTypes.DATE,
			format: 'x',
			formatDisplay: 'dd/mm/yyyy',
        },
        'show': {
            type: EntryTypes.STATIC,
            transform: (value) => DateHelper.timestampToDefault(value),
        },
		'table': {
			type: EntryTypes.TEXT,
        	label: 'Date',
			minWidth: TABLE.MIN_WIDTH.DATE,
            colOrder: 10,
            // css: {},
        	transform: (value) => DateHelper.timestampToDefault(value),
		}
	})
	datePrevEncaiss: string;
	@Entry({
		'create': {},
		'show': {},
	})
	datePrevEncaissTransient: any; // Objet contenant le timestamp dans le champ epoc pour avoir le format de IMyDateModel

	@Entry({
        base: {
            label: 'Montant (euros)',
			css: {
				group: 'col-xs-12',
				label: 'col-xs-4',
				input: 'col-xs-8'
			},
        },
		'create': {
			type: EntryTypes.NUMBER,
			validators: [Validators.required, Validators.pattern("^[0-9]*[.,]{0,1}[0-9]{0,2}$")],
			validatorsMsgs: {
				'required': 'Le montant est obligatoire',
				'pattern': 'Le montant doit être un nombre'
			},
        },
        'show': {
			type: EntryTypes.STATIC,
			transform: (value, row) => {
				return FormatHelper.toChaineMonetaire((row.isRemboursement) ? -value : value, true);
			},
        },
		'table': {
			type: EntryTypes.TEXT,
			label: 'Montant',
			minWidth: TABLE.MIN_WIDTH.PAIEMENT_MONTANT,
			colOrder: 11,
			transform: (value, row) => {
				return FormatHelper.toChaineMonetaire((row.isRemboursement) ? -value : value);
			},
		}
	})
	montantPaiement: number;

	dateModification: string;
	dateCreation: string;

	@Entry({
        base: {
            label: 'Tireur',
			css: {
				group: 'col-xs-12',
				label: 'col-xs-4',
				input: 'col-xs-8'
			},
        },
		'create': {
			type: EntryTypes.TEXT,
        },
        'show': {
            type: EntryTypes.STATIC,
        },
		'table': {
			type: EntryTypes.TEXT,
			label: 'Tireur',
			colOrder: 6,
        	minWidth: TABLE.MIN_WIDTH.NOM_PRENOM,
		}
	})
    tireur: string;

	@Entry({
        base: {
            label: 'Etablissement payeur',
			css: {
				group: 'col-xs-12',
				label: 'col-xs-4',
				input: 'col-xs-8'
			},
			transform: (value) => value ? (value.libelle ? value.libelle : value) : '',
        },
		'create': {
			type: EntryTypes.TEXT,
        },
        'show': {
			type: EntryTypes.STATIC,
        },
		'table': {
			type: EntryTypes.TEXT,
			label: 'Etab. payeur',
			colOrder: 8,
			minWidth: TABLE.MIN_WIDTH.PAIEMENT_ETAB,
			hidden: true,
		}
	})
	etabPayeur: string;

	@Entry({
        base: {
            label: 'Lieu',
			css: {
				group: 'col-xs-12',
				label: 'col-xs-4',
				input: 'col-xs-8'
			},
			transform: (value) => value ? (value.libelle ? value.libelle : value) : '',
        },
		'create': {
			type: EntryTypes.TEXT,
        },
        'show': {
			type: EntryTypes.STATIC,
        }
	})
	lieuEtabPayeur: string;
	// le paiement :
	// ne doit pas avoir de numéro de bordereau
	// ne doit pas être de type espèces
	static isSelectionBordereauPossible(element: PaiementModel): boolean {
		return !element.bordereauNumero && element.type !== 2;
	}

    constructor(data) {
		super();
		// Object.assign(this, data);
		this.isRemboursement = data.isRemboursement;
		this.type = data.type;
		this.libelleTypePaiement = data.libelleTypePaiement;
		this.numero = data.numero;
		this.datePrevEncaiss = data.datePrevEncaiss;
		// Initialisation du champ utilisé pour l'IHM
		const datePrevEncaissMoment = moment(this.datePrevEncaiss);
		this.datePrevEncaissTransient = {
			date: {
				year: datePrevEncaissMoment.year(),
				month: datePrevEncaissMoment.month() + 1,
				day: datePrevEncaissMoment.date()
			} };
		this.montantPaiement = data.isRemboursement ? -data.montantPaiement : data.montantPaiement;
		this.etabPayeur = data.etabPayeur ? (data.etabPayeur.libelle ? data.etabPayeur.libelle : data.etabPayeur) : '';
		this.lieuEtabPayeur = data.lieuEtabPayeur ? (data.lieuEtabPayeur.libelle ? data.lieuEtabPayeur.libelle : data.lieuEtabPayeur) : '';
		this.tireur = data.tireur;
		this.id = data.id;
		this.anneeScolaire = data.anneeScolaire;
		this.bordereauDate = data.bordereauDate;
		this.bordereauNumero = data.bordereauNumero;

		this.famille = new FamilleIdModel(data.familleId || (data.famille ? data.famille.id : null), data.famille);
		this.familleNom = data ? data.famille ? data.famille.nom : '' : '';
		this.familleId = data ? data.famille ? data.famille.id : null : null;
    }
}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/paiement/models/paiement.model.ts